import React, {  useLayoutEffect, useState } from "react";
import { getPrismicItems } from "../actions/prismicAction";
import { useDispatch } from "react-redux";
import { PDFBrochure } from "../components/MyTulu/PDFBrochure";
import getFirebase from "../firebase";
import { useParams } from "react-router-dom";
import { proposal } from "../globalState";
import {doc, getDoc, getFirestore} from "firebase/firestore";

const PDF = ({ id: pageFormID, setPDFMode, setLink }) => {
  const params = useParams().id;
  const id = String(pageFormID || params);
  const dispatch = useDispatch();
  const [data, setData] = useState();

  useLayoutEffect(() => {
    dispatch(getPrismicItems());

    const docId = id.replaceAll("__", " ");

    getFirebase();

    const db = getFirestore(getFirebase());
    const docRef = doc(db, "my_tulu", docId);

    getDoc(docRef).then((res) => {
      const data = res.data();

      setData(data);
      Object.keys(data).forEach((key) => {
        if (key === "columns" || key === "rideItems") {
          proposal[key] = JSON.parse(data[key]);
          return;
        }
        proposal[key] = data[key];
      });
    });
    // One-time initial fetch on mount; adding `id` would re-fetch on an id change
    // and dispatch is stable, so both are intentionally omitted to preserve behavior.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return (
    <span className="pdfRenderer">
      <PDFBrochure data={data} setPDFMode={setPDFMode} setLink={setLink} />
    </span>
  );
};

export default PDF;
